import { Box, Tooltip } from '@mui/material';
import {
  GridColDef,
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from '@mui/x-data-grid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { EditIcon, TrashIcon } from '../components/Icons';
import { ERole } from '../enums/user/ERole';
import { ETheme } from '../enums/user/ETheme';
import { formatDate } from '../functions/formatDate';
import { IEmployeeSkills } from '../interfaces/employeeSkills/IEmployeeSkills';
import { darkTheme, lightTheme } from '../mui/theme';

export const useEmployeeSkillColumns = (
  setSelectedItem: (employee: IEmployeeSkills) => void,
  setShowDeleteModal: (show: boolean) => void,
  setIsAddModalOpened: (show: boolean) => void,
): GridColDef[] => {
  const { t } = useTranslation();
  const { userData } = useSelector((state: RootState) => state.auth);

  return [
    { field: 'id', headerName: t('general.id'), width: 50 },
    {
      field: 'name',
      headerName: t('general.name'),
      flex: 1,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => {
        return <>{params.row?.name}</>;
      },
    },
    {
      field: 'createdAt',
      headerName: t('general.createdAt'),
      width: 150,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => {
        const { createdAt } = params?.row;
        return <div>{formatDate(createdAt)}</div>;
      },
    },
    {
      field: 'actions',
      headerName: t('general.action'),
      width: 100,
      hideable: false,
      sortable: false,
      headerClassName: userData?.role === ERole.USER ? 'hideColumn' : '',
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => {
        return (
          <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <Tooltip title={t('general.edit')}>
                <span
                  onClick={() => {
                    setIsAddModalOpened(true);
                    setSelectedItem(params?.row);
                  }}
                  className={'d-flex'}
                >
                  <EditIcon
                    fill={
                      userData?.theme === ETheme.LIGHT
                        ? lightTheme.palette.text.primary
                        : darkTheme.palette.text.primary
                    }
                  />
                </span>
              </Tooltip>
              <Tooltip title={t('general.delete')}>
                <span
                  className={'ms-3 d-flex'}
                  onClick={() => {
                    setSelectedItem(params?.row);
                    setShowDeleteModal(true);
                  }}
                >
                  <TrashIcon
                    fill={
                      userData?.theme === ETheme.LIGHT
                        ? lightTheme.palette.text.primary
                        : darkTheme.palette.text.primary
                    }
                  />
                </span>
              </Tooltip>
            </Box>
          </>
        );
      },
    },
  ];
};
